var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from '@servicetitan/design-system';
import { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import { observable, computed, runInAction, action, makeObservable } from 'mobx';
import { Input } from '@progress/kendo-react-inputs';
import { renderCustomColumnMenuFilter } from './column-menu-filters';
export function operator(item, value) {
    return value.includes(item);
}
export function fieldValuesColumnMenuFilter(tableState, renderItem = defaultRenderItem) {
    let FieldValuesFilterCell = class FieldValuesFilterCell extends Component {
        get processedData() {
            const searchQuery = this.searchQuery.toLowerCase();
            const filteredData = !searchQuery
                ? this.data
                : this.data.filter(v => v.text.toLowerCase().includes(searchQuery));
            return filteredData.slice().sort((a, b) => {
                if (a.text === b.text) {
                    return 0;
                }
                return a.text < b.text ? -1 : 1;
            });
        }
        get field() {
            const field = this.props.field;
            if (field === undefined) {
                throw 'missing field';
            }
            return field;
        }
        get value() {
            return this.props.value || [];
        }
        constructor(props) {
            super(props);
            Object.defineProperty(this, "data", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "searchQuery", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ''
            });
            Object.defineProperty(this, "handleSearchQueryChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (ev) => {
                    if (typeof ev.target.value === 'string') {
                        this.searchQuery = ev.target.value;
                    }
                }
            });
            Object.defineProperty(this, "handleChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (value, checked, ev) => {
                    const newFilterValue = checked
                        ? this.value.concat(value.value)
                        : this.value.filter((v) => v !== value.value);
                    const hasValue = newFilterValue.length > 0;
                    this.props.onChange({
                        value: hasValue ? newFilterValue : '',
                        operator: hasValue ? operator : '',
                        syntheticEvent: ev,
                    });
                }
            });
            makeObservable(this);
        }
        componentDidMount() {
            this.fetchData(tableState.dataSource);
        }
        render() {
            return (_jsxs(Fragment, { children: [_jsx(Input, { value: this.searchQuery, onChange: this.handleSearchQueryChange, placeholder: "Search", className: "m-b-1" }), this.processedData.map(item => (_jsx("span", { className: "k-widget d-b m-b-1", children: _jsx(Checkbox, { label: item.text, checked: this.value.includes(item.value), onChange: this.handleChange, value: item }) }, JSON.stringify(item))))] }));
        }
        async fetchData(dataSource) {
            if (!dataSource) {
                return;
            }
            const items = (await dataSource.getData({})).data;
            const values = items.map(i => i[this.field]);
            const distinctValues = values.filter((v, idx) => values.indexOf(v) === idx);
            runInAction(() => {
                this.data = distinctValues.map(value => ({ value, text: renderItem(value) }));
            });
        }
    };
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], FieldValuesFilterCell.prototype, "data", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], FieldValuesFilterCell.prototype, "searchQuery", void 0);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FieldValuesFilterCell.prototype, "processedData", null);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], FieldValuesFilterCell.prototype, "handleSearchQueryChange", void 0);
    FieldValuesFilterCell = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], FieldValuesFilterCell);
    return renderCustomColumnMenuFilter(FieldValuesFilterCell);
}
function defaultRenderItem(v) {
    if (v == null) {
        return '';
    }
    // suppose v has toString();
    return v.toString();
}
//# sourceMappingURL=field-values-filter.js.map